import React from "react";
import "../../styles/CompStyle/Footer.css"
export default function Footer() {
    return (
        <div className="Footer">
            <p className="copyright">
                &copy; 2023 Emerald Valley Academy. All rights reserved.
            </p>
        </div>
    );
}